import React from "react";
import {
  Card as ShadcnCard,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from "@/components/shadcn/card";
import { cn } from "@/lib/utils";
interface CardProps {
  title: string;
  total: string;
  content: string;
  className?: string;
}

export default function ProposeCard({ title, total, content, className }: CardProps) {
  return (
    <ShadcnCard className={cn("bg-[#030B12] rounded-2xl px-6 py-6 w-full min-h-50 max-h-85 text-white", className)}>
      <CardHeader className="p-0 mb-0 flex flex-row items-start justify-between gap-3">
        <CardTitle className="text-white font-bold text-4xl md:text-4xl leading-none m-0 p-0 shrink-0 whitespace-nowrap">{total}</CardTitle>
        <CardDescription className="text-white text-sm leading-snug m-0 p-0 line-clamp-2 wrap-break-word">{title}</CardDescription>
      </CardHeader>
      <CardContent className="p-0">
        <span className="line-clamp-4 text-base mt-2" dangerouslySetInnerHTML={{ __html: content }}></span>
      </CardContent>
    </ShadcnCard>
  );
}


